<template>
  <div>
    <van-sticky>
      <van-nav-bar title="修改交易密码" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <van-field label="手机号码" v-model="form.phone" placeholder="请输入手机号码" :readonly="true"></van-field>
    <!-- <van-field v-model="form.code" label="验证码" placeholder="请输入验证码">
      <van-button
        slot="button"
        size="small"
        type="primary"
        @click="send()"
        :disabled="!disabled"
      >{{codetext}}</van-button>
    </van-field> -->
    <van-field
      v-model="form.password"
      label="新密码"
      type="password"
      maxlength="6"
      placeholder="请输入密码"
    />
    <van-field
      v-model="form.password_re"
      label="确认新密码"
      type="password"
      maxlength="6"
      placeholder="请再次输入密码"
    />
    <div class="set-but" @click="submit">保存</div>
  </div>
</template>

<script>
import { updatePayPassword } from "@/api/personal";
import { sendSms } from "@/api/login";
export default {
  data() {
    return {
      value: "",
      disabled: true,
      codetext: "验证码",
      form: {
        old_password: "",
        password: "",
        password_re: "",
        phone: "",
        code: ""
      }
    };
  },
  created() {
    this.form.phone = localStorage.getItem("userPhone");
  },
  methods: {
    send() {
      sendSms({ phone: this.form.phone }).then(res => {
        this.countDown(60);
      });
    },
    countDown(time) {
      if (time === 0) {
        this.disabled = true;
        this.codetext = "获取";
        return;
      } else {
        this.disabled = false;
        this.codetext = "重新发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
    },
    submit() {
      updatePayPassword(this.form).then(res => {
		  this.$toast('提交成功!');
		  setTimeout(()=>{
            this.$router.go(-1);
		  },200)
	  });
    }
  }
};
</script>

<style lang="less" scoped>
.van-button--primary {
  background: rgba(255, 108, 26, 1);
  border: none;
  border-radius: 15px;
  height: 30px;
  color: white;
  padding:10px 20px;
}
.set-but {
  display: block;
  font-size: 18px;
  width: 345px;
  display: block;
  height: 35px;
  background: #3B6BFB;
  margin: 53px auto 0;
  border-radius: 17.5px;
  color: #fff;
  text-align: center;
  line-height: 35px;
}
</style>